import { React, useEffect, useState } from "react";
import PropTypes from "prop-types";

function PublicResearchList(props) {
    const {
        researchPositions, //List of all research positions
        selectedResearchPosition, //Currently selected research position
        setResearchPosition, //Function to set selectedResearchPosition
    } = props;

    const items = researchPositions.map((researchPosition, index) => (
        <button
            className={"ResearchPositionButton w-full capitalize p-2 rounded-md border-2 drop-shadow-2xl mb-2" + (researchPosition.positionId === selectedResearchPosition.positionId ? " border-brand-primary" : " border-gray")}
            key={index}
            type="button"
            onClick={() => setResearchPosition(researchPosition)}
        >
            <div className="ResearchPositionButton-compensation text-base font-brand-primary flex mb-2">
                {Array.isArray(researchPosition.researchPositionCompensation) ?
                researchPosition.researchPositionCompensation.join(", ") :
                researchPosition.researchPositionCompensation}
            </div>
            <div className="ResearchPositionButton-title text-xl font-bold font-brand-primary text-start flex mb-2">
                {researchPosition.title}
            </div>
            <div className="ResearchPositionButton-compensation text-base font-brand-primary flex mb-2">
                {Array.isArray(researchPosition.researchPositionType) ? researchPosition.researchPositionType.join(", ") : researchPosition.researchPositionType}
            </div>
            <div className="ResearchPositionButton-faculty text-base font-brand-primary flex">
                {researchPosition.facultyName}
            </div>
        </button>
    ));

    return (
        <div className="ResearchPositionsList h-full bg-white rounded-xl py-2 pl-2 pr-px">
            <div className="ResearchPositionsList-list overflow-y-auto h-full">
                {
                    researchPositions.length === 0 ?
                    "No research positions found." :
                    items
                }
            </div>
        </div>
    );
}

PublicResearchList.propTypes = {
  researchPositions: PropTypes.arrayOf(PropTypes.shape({
    applyCount: PropTypes.number,
    applyDetails: PropTypes.string,
    faculty: PropTypes.string,
    facultyLink: PropTypes.string,
    details: PropTypes.string,
    draft: PropTypes.bool,
    endDate: PropTypes.string,
    favorited: PropTypes.string,
    positionId: PropTypes.number,
    researchPositionResearchArea: PropTypes.arrayOf(PropTypes.string),
    researchPositionCompensation: PropTypes.arrayOf(PropTypes.string),
    researchPositionType: PropTypes.arrayOf(PropTypes.string),
    link: PropTypes.string,
    location: PropTypes.string,
    skills: PropTypes.arrayOf(PropTypes.string),
    startDate: PropTypes.string,
    title: PropTypes.string,
    pid: PropTypes.string,
    viewCount: PropTypes.number,
  })),
  selectedResearchPosition: PropTypes.shape({
    title: PropTypes.string,
    location: PropTypes.string,
    faculty: PropTypes.string,
    details: PropTypes.string,
    link: PropTypes.string,
    facultyLink: PropTypes.string,
    applyDetails: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    researchPositionType: PropTypes.arrayOf(PropTypes.string),
    researchPositionCompensation: PropTypes.arrayOf(PropTypes.string),
    researchPositionResearchArea: PropTypes.arrayOf(PropTypes.string),
    skills: PropTypes.arrayOf(PropTypes.string),
    location: PropTypes.string,
    viewCount: PropTypes.number,
    applyCount: PropTypes.number,
    favorited: PropTypes.string,
    positionId: PropTypes.number,
  }),
  setResearchPosition: PropTypes.func,
};

PublicResearchList.defaultProps = {
  researchPositions: [],
  selectedResearchPosition: {},
  setResearchPosition: () => { },
};

export default PublicResearchList;